import { render, staticRenderFns } from "./bar-x-percent.vue?vue&type=template&id=23527040&"
import script from "./bar-x-percent.vue?vue&type=script&lang=js&"
export * from "./bar-x-percent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports